// extracted by mini-css-extract-plugin
export default {"button-logout":"logoutButton_button-logout__JSawu"};